// extracted by mini-css-extract-plugin
export default {"root":"BlockIconCard_root__rkPc1","media":"BlockIconCard_media__cyaLX","text":"BlockIconCard_text__dNxPB"};